module.exports = __webpack_public_path__ + "img/104.2e4c4fa3.png";